import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../Context/LanguageContext';

const Footer = (props) => {
    const { t } = useLanguage();
    const [showBackToTop, setShowBackToTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowBackToTop(window.scrollY > 400);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    let networks = null;
    if (props.data && props.data.networks) {
        networks = props.data.networks.map(function (network) {
            return <li key={network.name}><a href={network.url} target="_blank" rel="noopener noreferrer" aria-label={network.name}><i className={`fa fa-${network.name}`} aria-hidden="true"></i></a></li>
        })
    }

    return (
        <>
            <footer>
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h3>{t('common.contactUs')}</h3>
                            <ul className="social-links">
                                {networks}
                            </ul>
                        </div>
                        <div className="footer-section">
                            <p className="copyright">&copy; {new Date().getFullYear()} KTGPB. {t('common.rightsReserved')}</p>
                            <p className="footer-links">
                                <Link to="/privacy">{t('common.privacy')}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

            <button 
                className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
                onClick={scrollToTop}
                aria-label="Back to top"
            >
                <i className="fa fa-chevron-up" aria-hidden="true"></i>
            </button>
        </>
    );
};

export default Footer;